import React, { Fragment } from 'react'
import Navigation from 'Components/Navigation'

// CSS
import './SearchReturnsVadIvend.css'
import { useColumnSearchReturn } from './hooks/useColumnSearchReturn'
import { SearchDocumentsVadIvendProvider } from 'state/context/SearchDocumentsVadIvendContext'
import { TableSearchDocuments } from 'Components/TableSearchDocuments/TableSearchDocuments'

function SearchReturnsVadIvend() {
  const columns = useColumnSearchReturn()

  return (
    <SearchDocumentsVadIvendProvider documentType="CreditNote">
      <Fragment>
        <Navigation showChangeBranch={false} />
        <section
          className="common-search-content"
          data-testid="container-search-returns">
          <header className="common-search-header">
            <h2>Buscar Devoluciones</h2>
          </header>
          <TableSearchDocuments columns={columns} />
        </section>
      </Fragment>
    </SearchDocumentsVadIvendProvider>
  )
}

export default SearchReturnsVadIvend
